<template>
  <svg width="32" height="32" viewBox="0 0 32 32">
    <path
      d="M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12c-1.8 0-3.508-.397-5.041-1.107-1.456-.348-4.144 1.028-4.96.971-.325.017-.485-.252-.297-.383 1.275-.892 1.916-2.392 1.738-3.075A11.948 11.948 0 0 1 4 16C4 9.373 9.373 4 16 4zm-.347 16.905a1.282 1.282 0 0 0 0 2.562c.71 0 1.28-.572 1.28-1.281 0-.71-.57-1.281-1.28-1.281zm.316-12.372c-1.765 0-3.24.884-3.87 2.377a2.773 2.773 0 0 0-.232 1.07c0 .556.337.93.878.93.441 0 .77-.273.903-.73.34-1.272 1.1-1.85 2.26-1.85 1.346 0 2.308.81 2.308 1.991 0 .91-.39 1.437-1.52 2.278l-.262.197c-1.18.915-1.734 1.783-1.734 2.954v.448l.007.15c.053.536.394.878.94.878.566 0 .898-.396.916-1v-.256l.008-.173c.054-.78.368-1.172 1.472-1.957 1.4-1.002 2.09-2.09 2.09-3.519 0-2.3-1.732-3.788-4.164-3.788z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
